module.exports = __webpack_public_path__ + "img/c04_buildingtechrigoroustraining_Normal_ua.cd5d45a6.webp";